import PageStyle from "@/styles/components/share-cv/_index.module.scss";
import AutomationStyle from "@/styles/components/automation-popup/_index.module.scss";
import ModalStyle from "@/styles/components/modal/add-assessment/_index.module.scss";
import Button from "@/components/button";
import Tooltip from "react-simple-tooltip";
import Phone from 'public/icons/call2.svg';
import Tech from 'public/icons/technical.svg';
import Video from 'public/icons/video.svg';
import Face from 'public/icons/user.svg';
import VideoQA from 'public/icons/videoqa.svg';
import {components} from "react-select";
import ButtonStyle  from '@/styles/components/button/_index.module.scss';
import Autosuggest from 'react-autosuggest';
import PlaceAutoComplete from 'react-places-autocomplete';
import {Loading} from '@/components/loading';
import Exclamation from 'public/icons/exclamation.svg';
import { AutocompleteError, Field, FieldArray, Form, Formik, FormikControl, useState, INTERVIEW_TYPES, useRef, InputText } from '@/imports-files/common/common';
import {AssessmentDropZone, EXTENSION_COMMON, DragDropContext, Droppable, Draggable } from '@/imports-files/pages/clients/recruitments/manage-assessment';
import { Page, Image, InputError, useTranslation, isCustomLink, useRouter, useEffect, Deleteicon, AddInterviewManualAction} from "@/imports-files/pages/clients/jobs/candidate-profile-job";
import { setFilledDate } from "@/imports-files/components/job-filters";
import { CONSTANTS } from "@/imports-files/components/model/setup-video-qa";
import ClientDashboard from 'src/layouts/ClientDashboard';
import {reviewAutomationEmail} from '@/imports-files/pages/clients/candidates/kanban';
import { onSuggestionsFetchRequested, renderSuggestion, shouldRenderSuggestions, handleKeyDown,  handleInterviewFormSubmit, toggleDisabled, runAutomations, interviewTypeHeader, TechTestAction, cursorNone, validations, renderLabel, handleVideoQAFormSubmit, setUpTechTest, defaultTestDetail, VideoQaAction, userHash, setUpVideoQAMember, JOB_STAGES, CustomToastrAction} from "@/imports-files/pages/clients/jobs/automations";
import { setupInterviewInitialValues } from '@/imports-files/components/setup-interview';
import { initialStageValues, showHideButtonValue, onAutomationChange, isLocationDisabled, onSuggestionSelection, addMinutes, addManualKanbanInterview, validationManualform, handleDelete, renderInputComponent} from "@/imports-files/pages/clients/jobs/candidate-profile-job";
import Modal from "./common-modal/modal";
import { FormModalStyle, Close } from "@/imports-files/components/common-modal/common-modal";
import PracticeExclamation from "public/new-icons/info-icon.svg";
import AddIcon from "public/icons/thick-plus.svg"



export function SetupInterviewModal(props){
  var initialValues                                                           =     setupInterviewInitialValues(props.currentStage, props.isPrimaryinterview)
  var currentStage                                                            =     props.currentStage
  const [current_interview_type, setCurrentInterviewType]                     =     useState(props.isPrimaryinterview ? currentStage?.interview_type : '')
  // initialValues.children_attributes.map((x) => x.interview_type    =     initialValues.interview_type)
  // initialValues.default_location                                              =     initialValues.job_meeting_details_attributes[0]?.location_attributes?.full_address || currentStage?.default_location
  // initialValues.place_id                                                      =     initialValues.job_meeting_details_attributes[0]?.location_attributes?.place_id || currentStage?.place_id
  const [tests, setTests] = useState([])
  const techTestAction = new TechTestAction(setTests);
  const videoQaAction = new VideoQaAction(setTests);
  // if(currentStage.interview_type == INTERVIEW_TYPES.TECHTEST) (initialValues = setUpTechTest(initialValues, techTestAction, currentStage))
  // if(currentStage.interview_type == INTERVIEW_TYPES.VIDEOQA) (initialValues = setUpVideoQAMember(initialValues, currentStage))
  const { Option }                                                            =     components;
  const setBtnPopup                                                           =     props.setBtnPopup
  const setOnLoadValues                                                       =     props.setOnLoadValues
  const platforms                                                             =     props.currentStage.platforms
  const [interviewStageCount, setInterviewStageCount]                         =     useState(initialValues.children_attributes.length)
  const [users, setUsers]                                                     =     useState([]);
  const [totalDuration, setTotalDuration]                                     =     useState(initialValues.children_attributes.map(x => x.duration).reduce((a,b) => {
                                                                                                                                                                                  a = parseInt(a) || 0;
                                                                                                                                                                                    b = parseInt(b) || 0;
                                                                                                                                                                                  return a+b}, 0))
  const router                                                                =     useRouter();
  const [stageEmail, setStageEmail]                                           =     useState(initialStageValues(initialValues));
  const duration                                                              =     props.duration
  const editable                                                              =     props.editable
  const { t, i18n }                                                           =     useTranslation();
  const [isLoading, setLoading]                                               =     useState(true);
  const [ isDisabled, setDisabled]                                            =   useState(false);
  const [ showHideButton, setShowHideButton]                                  =   useState(showHideButtonValue(initialValues));
  const interviewTypes                                                        =   props.currentStage.interview_types
  const [disabledAddMoreQuestion, setDisabledAddMoreQuestion]                 =   useState(false);
  const [deleteQuestionList, setDeleteQuestionList]                           =   useState([]);
  const [flagForRender, setFlagForRender]                                     =   useState(0);
  const addInterviewManualAction                            =   new AddInterviewManualAction(setFlagForRender, deleteQuestionList, setDeleteQuestionList, setDisabledAddMoreQuestion);
  const [ languageListing, setLanguageListing]              =   useState(addInterviewManualAction.setLanguageList(props.currentStage.language_list));
  const [techTest, setTechTest]             =   useState(initialValues.job_test_detail_attributes?.test_name ? initialValues.job_test_detail_attributes.test_name : '');
  const [techStageEmail, setTechStageEmail] = useState({value: '', error: ''});
  const [validationData, setValidationData] = useState({type: initialValues.job_test_detail_attributes?.test_type || 'TestLibrary', test_id: initialValues.job_test_detail_attributes?.test_id?.toString() || ''});
  const [buttonState, setButtonState] = useState('');
  const [disabledSaveButton, setDisabledSaveButton] =   useState(false);
  const [uploadFileText, setUploadFileText] = useState('Upload a file')
  const customToastrAction     =  new CustomToastrAction();
  const [addType, setAddType]  =   useState('range')
  const [sendInterview, setSendInterview]                   =   useState(false);
  const [isSingleCandidate, setIsSingleCandidate] = useState(props.selectedCards.job_application_ids.indexOf('all') == -1 && props.selectedCards.job_application_ids.length == 1);
  const formRef = useRef(null);
  useEffect(() => {
                    (async () => {
                                  setLoading(false);
                                })();
                  },[])

  if(isLoading)
  {
      return '';
  }

  function interviewSwitchButton(type) {
    switch(type) {
      case INTERVIEW_TYPES.PHONE:
        return <Phone/>;
      case INTERVIEW_TYPES.TECHTEST:
        return <Tech className="techIcon"/>;
      case INTERVIEW_TYPES.VIDEO:
        return <Video/>;
      case INTERVIEW_TYPES.FACE2FACE:
          return <Face className="faceIcon"/>
      case INTERVIEW_TYPES.VIDEOQA:
          return <VideoQA className="videoQAIcon"/>
      default:
        return '';
    }
  }

  const IconOption = props => {
    return (
    <Option {...props}>
        <div className={PageStyle.Selectimg}>
        <img
        // src={`/images/pages/automation/${props.data.label.replace(' ', '_').toLowerCase()}.png`}
        src={`${props.data.logo_url}`}
        style={{ marginRight: 12, width: 20, height: 20, verticalAlign: "middle" }}
        alt={props.data.label}
      />
      {props.data.label}
      </div>
    </Option>
    )
  };

  function gridClass(current_interview_type){
    return current_interview_type == INTERVIEW_TYPES.VIDEO ? PageStyle.SetupPopup__ContentGrid : AutomationStyle.AutomationPopup__ContentGridPhone
  }

  return (
    <Modal type="form" closeModal =   {()=> setBtnPopup(false)} heading = {`${interviewTypeHeader(current_interview_type, t).header}`} description = {`${interviewTypeHeader(current_interview_type, t).subheader}`} content = {
        <Formik
          initialValues     = {initialValues}
          validationSchema  = {validationManualform(addType, current_interview_type, sendInterview, platforms, validationData)}
          onSubmit          = {async (values, actions)=>{
              if(validationData.type == 'Assessment' && validationData.test_id == 'upload_new_test')
              {
                values.save_and_continue = buttonState == 'save_and_continue' ? true : false
              }
              if(props.from == "kanban") props.setActionBar(false);
              let email_data = await reviewAutomationEmail(router.query.job_id, router, { key: "add_interview", list: true})
               if(addType == "time" && [INTERVIEW_TYPES.PHONE, INTERVIEW_TYPES.VIDEO, INTERVIEW_TYPES.FACE2FACE].includes(current_interview_type)){
                props.setAddInterviewBar({ active: true, action: {values: values, router: router, setBtnPopup: setBtnPopup, setInitialData: props.setJobData || props.setInitialData, setLoading: props.setLoading, current_interview_type: current_interview_type, setFlagForRender: setFlagForRender, setDisabledSaveButton: setDisabledSaveButton, from: "manual_kanban_interview", props: props } });
                props.setReviewKey("add_interview");
                props.setEmailData(email_data);
                props.setUnsuccessfulEmailModal({state: true});
                setBtnPopup(false)
              }else{
              await addManualKanbanInterview(values, router, setBtnPopup, props.setJobData || props.setInitialData, props.setLoading, current_interview_type, setFlagForRender, setDisabledSaveButton, props, t);
            }
          }}
        >
          {(formik) => (
            <Form>
              <div className={'AddInterview AutomationPopup'}>
                <div className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading} mt30`}>
                  <label><span className={`red-color`}>*</span>&nbsp;{t('modal:automation:interview:type')}
                  </label>
                </div>

                <div>
                  <div className={`Dpflex mb0`}>
                    {interviewTypes.map((x, interviewIndex) => {
                      return (
                        <div className={PageStyle.Interview__Icons} key={`interview_type_${interviewIndex}`}>
                          <Tooltip background={'#00325A'} radius={50} placement = "top" fontSize= "12px" content= {x.name} key= {x.name} padding={12} className='SimpleTooltip'>
                          <p className={`${PageStyle.Interview__IconsType} tooltipwidthinterview100`}>
                            <input type="radio" name="interview_type_id" id={`icon${interviewIndex}`} checked = {formik.values.interview_type_id == x.id}
                                                          onClick={async() => {
                                                              let old_interview_type = formik.values.interview_type
                                                              formik.setFieldValue('interview_type_id', x.id)
                                                              formik.setFieldValue('interview_type', x.name)
                                                              currentStage.interview_type = x.name
                                                              await setCurrentInterviewType(x.name)
                                                              let uniq_member_emails = []
                                                              let uniq_member_initials = []
                                                              let children_attributes = formik.values.children_attributes
                                                              children_attributes.map((x) => {
                                                                if(!x._destroy && x.member_emails?.length > 0){
                                                                  x.member_emails.map((member_email, member_email_index) => {
                                                                    if(!uniq_member_emails.includes(member_email)){
                                                                      uniq_member_emails.push(member_email)
                                                                      uniq_member_initials.push(x.member_initials[member_email_index])
                                                                    }
                                                                    return member_email
                                                                  })
                                                                }
                                                                x._destroy = true
                                                                return x
                                                              })
                                                              if(old_interview_type && old_interview_type  == INTERVIEW_TYPES.TECHTEST){
                                                                uniq_member_emails = formik.values.job_test_detail_attributes.member_emails
                                                                uniq_member_initials = formik.values.job_test_detail_attributes.member_initials
                                                              }
                                                              if(old_interview_type && old_interview_type  == INTERVIEW_TYPES.VIDEOQA){
                                                                uniq_member_emails = formik.values.videoqa.member_emails
                                                                uniq_member_initials = formik.values.videoqa.member_initials
                                                              }
                                                              if([INTERVIEW_TYPES.PHONE, INTERVIEW_TYPES.VIDEO, INTERVIEW_TYPES.FACE2FACE].includes(x.name)){
                                                                children_attributes.push({
                                                                  date: '',
                                                                  starttime: '',
                                                                  endtime: '',
                                                                  location: formik.values.default_location || '',
                                                                  place_id: formik.values.place_id || '',
                                                                  integration_id: '',
                                                                  members: [],
                                                                  member_ids: [],
                                                                  members: [],
                                                                  duration: '',
                                                                  _destroy: false
                                                                })
                                                                setStageEmail(initialStageValues(formik.values))
                                                                let durations = []
                                                                setTotalDuration(durations.reduce((a,b) => (parseInt(a) || 0) + (parseInt(b) || 0), 0))
                                                                setInterviewStageCount(1)
                                                              }

                                                              if(x.name == INTERVIEW_TYPES.TECHTEST){
                                                                await setValidationData({type: 'TestLibrary', test_id: ''})
                                                                await formik.setFieldValue('job_test_detail_attributes', defaultTestDetail(uniq_member_emails, uniq_member_initials))
                                                              }
                                                              if(x.name == INTERVIEW_TYPES.VIDEOQA){
                                                                let videoqa = {
                                                                  member_emails:  uniq_member_emails,
                                                                  member_initials: uniq_member_initials
                                                                }
                                                                formik.setFieldValue('videoqa', videoqa)
                                                              }
                                                        }}/>
                            <label htmlFor={`icon${interviewIndex}`} className={`labelcolor`}>
                            {interviewSwitchButton(x.name)}
                            </label>
                          </p>
                          </Tooltip>
                        </div>
                        )
                    })}
                  </div>
                  <AutocompleteError
                    name={'interview_type_id'}
                    errorClass={PageStyle.Form__Error}
                    custom_class = {`FieldError`}
                    formik = {formik}
                    style={InputError(formik, 'interview_type_id')}
                  />
                </div>


            {current_interview_type == INTERVIEW_TYPES.VIDEOQA ?
                <div>
                    {/* ----------------- VIDEO QA Members DIV */}
                    <div className={`${PageStyle.SetupPopup__SetupVideoQa2} ${AutomationStyle.AutomationPopup__SetupVideoQa2} mb0`}>
                      <div className = { `${AutomationStyle.AutomationPopup__Row}`}>
                        <div className = {`${AutomationStyle.AutomationPopup__Members} ${PageStyle.Form__TableCol} mt30 mb10`}>
                            <label className={`${PageStyle.Form__FloatingLabel}`} style={InputText(formik, `videoqa.member_emails`)}>
                            {t('modal:input:members')}</label>
                          <div className = {`${AutomationStyle.AutomationPopup__Field}`}>
                            <Autosuggest
                                suggestions={users}
                                onSuggestionsFetchRequested={({value}) => onSuggestionsFetchRequested(value, currentStage, setUsers, router)}
                                onSuggestionsClearRequested={() => setUsers([])}
                                getSuggestionValue={(suggestion) => `${suggestion.user_attributes.email}`}
                                renderSuggestion={renderSuggestion}
                                renderInputComponent={videoQaAction.renderMemberInputComponent}
                                shouldRenderSuggestions={videoQaAction.shouldRenderSuggestions}
                                onSuggestionSelected={(event, {suggestion}) => {
                                  if(suggestion.user_attributes.email.length > 0)
                                  {
                                    setTechStageEmail({value: ''})
                                    videoQaAction.onSuggestionSelection(formik, formik.values.videoqa.member_emails, suggestion.user_attributes.email, formik.values.videoqa.member_initials, {email: suggestion.user_attributes.email, name_initials: suggestion.user_attributes.name_initials, name: suggestion.user_attributes.name })
                                    formik.validateForm();
                                  }
                                }}
                                inputProps={{
                                  className: `${PageStyle.Form__Input} ${PageStyle.Form__textleft} ${PageStyle.Form__InputFullWidth}`,
                                  placeholder: t('placeholder:search:type_name'),
                                  value: techStageEmail.value,
                                  disabled: !editable,
                                  editable: editable,
                                  selectedValues: formik.values.videoqa?.member_initials,
                                  closeIcon: <Close/>,
                                  formik: formik,
                                  videoQaAction: videoQaAction,
                                  add_button: false,
                                  name: `videoqa.member_emails`,
                                  onChange: (value, {newValue, method}) => {
                                    setTechStageEmail({value: newValue, error: ''})
                                  },
                                  setStageEmail: setTechStageEmail,
                                  // onKeyDown: (event) => videoQaAction.handleKeyDown(event, formik, setTechStageEmail)
                                }
                                }
                              >
                            </Autosuggest>
                            <AutocompleteError
                              name={`videoqa.member_emails`}
                              errorClass={PageStyle.Form__Error}
                              formik = {formik}
                              style={InputError(formik, `videoqa.member_emails`)}
                              />
                          </div>
                      </div>
                    </div>
                  </div>
                    {/* ----------------- VIDEO QA Members DIV */}


                  <div className = { `${AutomationStyle.AutomationPopup__Row}`}>
                    <div className = {`${AutomationStyle.AutomationPopup__w50}`}>
                      {/* ----------------- LANGUAGE DIV -----------------*/}
                      <div className={`${AutomationStyle.InterviewType__SetupVideoQa2} ${PageStyle.Form__TableCol} mt20 mb10`}>
                        <label className={`${gridClass(current_interview_type)} ${PageStyle.Form__FloatingLabel}`}>
                          <span className={`red-color`}>*</span>&nbsp;{t('modal:input:language')}</label>
                         <div className = {`${AutomationStyle.AutomationPopup__Field}`}>
                            <FormikControl
                              className={`${PageStyle.Form__CustomSelect} ${AutomationStyle.Form__CustomSelect}`}
                              control="select"
                              formik={formik}
                              name = 'language'
                              options={languageListing}
                              placeholder={t('placeholder:search:language')}
                              style={InputError(formik, `language`)}
                              default = {'English'}
                              onChange={(data) => {
                                            formik.setFieldValue("language", data.value)
                                        }}
                            />
                        </div>
                      </div>
                      {/* ----------------- LANGUAGE DIV -----------------*/}
                  </div>
                  <div className = {`${AutomationStyle.AutomationPopup__w50}`}>
                     {/* ----------------- INTRO VIDEO DIV -----------------*/}
                    <div className={`${AutomationStyle.InterviewType__SetupVideoQa2} ${PageStyle.Form__TableCol} mt20 mb10`}>
                        <label className={`${gridClass(current_interview_type)} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, `video_link`)}>
                          {t('modal:input:intro_video')}
                        </label>
                      <div className = {`${AutomationStyle.AutomationPopup__Field}`}>
                        <FormikControl
                          className={`${PageStyle.Form__Input} thresholdmodl`}
                          control="input"
                          type="text"
                          formik={formik}
                          name = 'video_link'
                          placeholder={CONSTANTS.texts.placeholder_intro_video}
                          style={InputError(formik, `video_link`)}
                          custom_error_90={'custom_error_90'}
                          custom_class = {`FieldError`}
                        />
                      </div>
                    </div>
                     {/* ----------------- INTRO VIDEO DIV -----------------*/}
                  </div>
                </div>
                    {/* ----------------- INTERVIEW QUESTION DIV -----------------*/}
                    <div className = { `${AutomationStyle.AutomationPopup__Row}`}>
                      <div className = {`${AutomationStyle.AutomationPopup__InterviewQuestion} mt30`}>
                        {formik?.values?.questions_attributes?.map((question,index)=>{
                        return(
                          <div key={`question_key_${index}`} className={`${PageStyle.SetupPopup__QuestionSection} ${AutomationStyle.AutomationPopup__QuestionSection}`}>
                            <h3 className={`Dpflex JustifySpace`}>{t('modal:input:interview_question')} {index+1}
                              {formik.values.questions_attributes.length > 1 &&<Deleteicon  className={`${FormModalStyle.Modal__Container__IconSvg}`} onClick={()=>{addInterviewManualAction.onDeleteClick(formik, index)}}/>}
                            </h3>
                            <div className = { `${AutomationStyle.AutomationPopup__Question} ${PageStyle.Form__TableCol} mt30 mb10`}>
                                <label className={`${gridClass(current_interview_type)} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, `questions_attributes.${index}.question`)}><span className={`red-color`}>*</span>&nbsp;{t('modal:input:question')}</label>
                              <div className = {`${AutomationStyle.AutomationPopup__Field}`}>
                                <FormikControl
                                  className={`${PageStyle.Form__Input} ${AutomationStyle.Form__Input} input600`}
                                    control="input"
                                    type="text"
                                    formik={formik}
                                    placeholder={t('placeholder:question')}
                                    name={`questions_attributes.${index}.question`}
                                    custom_class = {`FieldError`}
                                    style={InputError(formik, `questions_attributes.${index}.question`)}
                                    onChange={(data)=>{
                                                    formik.setFieldValue(`questions_attributes.${index}.question`, data.target.value);
                                                    (formik.status && formik.status['questions_attributes'] && formik.status['questions_attributes'][index] && formik.status['questions_attributes'][index]['question']) ? delete formik.status['questions_attributes'][index]['question'] : '';
                                                    formik.setStatus(formik.status);
                                                  }}
                                />
                            </div>
                          </div>
                          <div className = { `${AutomationStyle.AutomationPopup__Description} ${PageStyle.Form__TableCol} mt30`}>
                              <div className={`${gridClass(current_interview_type)}  ${PageStyle.Form__FloatingLabel} mb10`}>
                                  <label style={InputText(formik, `questions_attributes.${index}.description`)}>{t('modal:input:description')}</label>
                              </div>
                              <div className = {`${AutomationStyle.AutomationPopup__Field}`}>
                              <FormikControl
                                control="customtextarea"
                                type="text"
                                formik={formik}
                                className={`${PageStyle.Form__Textarea} ${AutomationStyle.Form__Textarea} input600`}
                                name={`questions_attributes.${index}.description`}
                                rows="4"
                                style={InputError(formik, `questions_attributes.${index}.description`)}
                              />
                            </div>
                          </div>
                          <div className={`Dpflexonly AlignBaseline ${AutomationStyle.AutomationPopup__TwoFields}`}>
                            <div className = {`${AutomationStyle.AutomationPopup__Time} ${PageStyle.Form__TableCol} Dpflexonly AlignBaseline w100 mt20`}>
                              <div className={`${gridClass(current_interview_type)} ${PageStyle.Form__FloatingLabel} wauto mb10`}>
                                <label style={InputText(
                                              formik,
                                              `questions_attributes.${index}.answer_time`
                                            )}><span className={`red-color`}>*</span>{t('modal:input:time_to_answer')}</label>
                              </div>
                              <div className = {`${AutomationStyle.AutomationPopup__FieldAuto} ${AutomationStyle.AutomationPopup__NoRightBorderRadius}  w50`}>
                                <div className = {`Dpflexonly`}>
                                  <Field
                                  component={addInterviewManualAction.NumberField}
                                  defaultValue={30}
                                  type="text"
                                  name={`questions_attributes.${index}.answer_time`}
                                  className={`${PageStyle.Form__Input} ${AutomationStyle.Form__InputFocus} width60 inputerrorheight`}
                                  formik={formik}
                                  format={'###'}
                                  style={InputError(formik, `questions_attributes.${index}.answer_time`)}
                                  onValueChange={(value)=>{
                                                            formik.setFieldValue(`questions_attributes.${index}.answer_time`, value.floatValue);
                                                            (formik.status && formik.status['questions_attributes'] &&  formik.status['questions_attributes'][index] && formik.status['questions_attributes'][index]['answer_time']) ? delete formik.status['questions_attributes'][index]['answer_time'] : '';
                                                            formik.setStatus(formik.status);
                                                          }}
                                  />
                                  <span
                                    className = {`${AutomationStyle.AutomationPopup__Seconds} ${PageStyle.Form__currency_symbol} ${PageStyle.Form__currency_symbol__right}`}
                                    style={InputError(formik, `questions_attributes.${index}.answer_time`)}
                                    >{t('modal:input:sec')}</span>
                              </div>

                              <AutocompleteError
                                    name={`questions_attributes.${index}.answer_time`}
                                    errorClass={PageStyle.Form__Error}
                                    formik={formik}
                                    custom_class = {`FieldError`}
                                    style={InputError(formik, `questions_attributes.${index}.answer_time`)}
                                  />
                            </div>
                            </div>
                            <div className = {`${AutomationStyle.AutomationPopup__Time} ${PageStyle.Form__TableCol} Dpflexonly AlignBaseline JustifyEnd w100 mt30 mb10`}>
                               <div className={`${gridClass(current_interview_type)} ${PageStyle.Form__FloatingLabel} wauto mb10`}>
                                <label className={`text-center`} style={InputText(formik,`questions_attributes.${index}.attempts`)}>
                                  <span className={`red-color`}>*</span> {t('modal:input:attempts:number')} &nbsp;
                                    <Tooltip
                                        content={t('modal:input:attempts:max')}
                                        background={"#203040"}
                                        radius={4}
                                        padding={8}
                                        placement="right"
                                        fontSize="12px"
                                        className='SimpleTooltip'
                                      >
                                        <p className={`tooltipwidthinterview140`}>
                                          <Exclamation />
                                        </p>
                                      </Tooltip>
                                </label>
                            </div>
                            <div className={`${AutomationStyle.AutomationPopup__FieldAuto} Dpflexonly AlignBaseline w50`}>
                              <div>
                                <Field
                                  component={addInterviewManualAction.NumberField}
                                  defaultValue={2}
                                  type="text"
                                  name={`questions_attributes.${index}.attempts`}
                                  className={`${PageStyle.Form__Input} ${AutomationStyle.Form__InputFocus} width100 inputerrorheight text-center`}
                                  formik={formik}
                                  format={'#'}
                                  onValueChange={(value)=>{
                                                            formik.setFieldValue(`questions_attributes.${index}.attempts`, value.floatValue);
                                                            (formik.status && formik.status['questions_attributes'] && formik.status['questions_attributes'][index] && formik.status['questions_attributes'][index]['attempts']) ? delete formik.status['questions_attributes'][index]['attempts'] : '';
                                                            formik.setStatus(formik.status);
                                                          }}
                                  style={InputError(formik, `questions_attributes.${index}.attempts`)}
                                />
                                <AutocompleteError
                                  name={`questions_attributes.${index}.attempts`}
                                  errorClass={PageStyle.Form__Error}
                                  formik={formik}
                                  style={InputError(formik, `questions_attributes.${index}.attempts`)}
                                />
                              </div>
                            </div>
                          </div>
                          </div>


                        </div>)
                        })}
                      </div>
                    </div>
                    {/* ----------------- INTERVIEW QUESTION DIV -----------------*/}

                    {/* ----------------- ADD QUESTON SECTION -----------------*/}

                      <div className={`${PageStyle.SetupPopup__AddQuestion} ${AutomationStyle.AutomationPopup__AddQuestionButton} ${PageStyle.mt15}`}>
                        <Button
                          buttonstyle={`${ButtonStyle.iconTextButton}`}
                          type="button"
                          disabled = {disabledAddMoreQuestion}
                          onClick={()=> addInterviewManualAction.onAddClick(formik)}
                        >
                        <AddIcon />
                         {t('button:add:question')}
                        </Button>
                      </div>
                    {/* ----------------- ADD QUESTON SECTION -----------------*/}

                    {/* ----------------- CUSTOMISATION DIV ----------------- */}
                    <div className="mb30 mt40">
                    <h4 className={` ${PageStyle.SetupPopup__ContentBlock} ${AutomationStyle.AutomationPopup__Customisation} mt0`}>
                    {t('modal:automation:customisations')}
                    </h4>
                    <div className={`Dpflex`}>
                    <div className={`${PageStyle.SetupPopup__ContentCustomisation} ${AutomationStyle.AutomationPopup__PracticeScreen} ${PageStyle.SetupPopup__AddInterviewCustomisation}`}>
                    <div className={`thresholdmodl ${AutomationStyle.AutomationPopup__SetupVideoQa3}`}>
                      <h3 className={`Dpflexonly`}>
                      {t('modal:input:practice_screen')}
                        <span
                          className={`${PageStyle.Interview__BestMatchExclamation} ${AutomationStyle.AutomationPopup__PracticeExclamation}`}
                        >
                          <Tooltip
                            content={t('agency:video:practice_question')}
                            background={"#203040"}
                            radius={20}
                            padding={8}
                            placement="right"
                            fontSize="12px"
                            className='SimpleTooltip'
                          >
                            <p className={`tooltipwidthinterview200`}>
                              <PracticeExclamation />
                            </p>
                          </Tooltip>
                        </span>
                      </h3>
                      <label className={PageStyle.IntegrationTable__switch}>
                        <input type="checkbox" defaultChecked={formik.values.practise_screen} onChange={(event) => {formik.setFieldValue('practise_screen',event.target.checked)}}/>
                        <span
                          className={`${PageStyle.IntegrationTable__slider} ${PageStyle.IntegrationTable__round} width44`}
                        ></span>
                      </label>
                    </div>
                    </div>

                    <div className={`${PageStyle.SetupPopup__ContentCustomisation} ${PageStyle.SetupPopup__PushTop} ${PageStyle.SetupPopup__SetupVideoQa4} ${AutomationStyle.AutomationPopup__SetupVideoQa4} ${PageStyle.Form__TableCol}`}>
                    <label className={`Dpflexonly AlignBaseline ${PageStyle.mb15} ${PageStyle.Form__FloatingLabel} mr10`} style={InputText(formik, `expires`)}>
                        <span className={`red-color`}>*</span> {t('modal:input:expires')}
                      </label>
                      <div className = {`${AutomationStyle.AutomationPopup__FieldAuto} ${AutomationStyle.AutomationPopup__NoRightBorderRadius} w50`}>
                      <div className = {`${AutomationStyle.AutomationPopup__NoRightBorderRadius} Dpflexonly`}>
                        <Field
                          component={addInterviewManualAction.NumberField}
                          type="text"
                          name={'expires'}
                          className={`${PageStyle.Form__Input} ${AutomationStyle.Form__InputFocus} thresholdmodl width70`}
                          formik={formik}
                          format={'###'}
                          style={InputError(formik, `expires`)}
                          defaultValue={2}
                          onValueChange={(value)=>{
                                                    formik.setFieldValue(`expires`, value.floatValue);
                                                    formik.setStatus['expires'] = ''
                                                  }}
                        />
                        <span
                        className = {`${AutomationStyle.AutomationPopup__Seconds} ${PageStyle.Form__currency_symbol} ${PageStyle.Form__currency_symbol__right} ml0`}
                        style={InputError(formik, `expires`)}
                        >{t('modal:input:days')}</span>
                        </div>
                        <AutocompleteError
                          name={"expires"}
                          errorClass={PageStyle.Form__Error}
                          formik={formik}
                          custom_class = {`FieldError`}
                          style={InputError(formik, `expires`)}
                        />
                      </div>
                    </div>
                    </div>
                    </div>
                    {/* ----------------- CUSTOMISATION DIV ----------------- */}
                </div>

            : <div>
               <FieldArray className={``} name="children_attributes" render={(arrayHelpers) =>
                {return formik.values.children_attributes.map((item, index) => {
                return (!item._destroy && <>

                 {/* Interview Type Phone */}

                  {current_interview_type == INTERVIEW_TYPES.PHONE && <div className = {`${AutomationStyle.InterviewType__Phone}`}>
                  <div className = { `${AutomationStyle.AutomationPopup__Row}`}>
                    <div className = {`${AutomationStyle.AutomationPopup__Members} ${PageStyle.Form__TableCol} mt30 mb20`}>
                       <label className={`${gridClass(current_interview_type)} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, `children_attributes.${index}.member_ids`)}>
                        <span className={`red-color`}>*</span>&nbsp;{t('modal:input:members')}</label>

                       <div className = {`${AutomationStyle.AutomationPopup__Field}`}>
                          <Autosuggest
                          suggestions={users}
                          onSuggestionsFetchRequested={({value}) => onSuggestionsFetchRequested(value, currentStage, setUsers, router)}
                          onSuggestionsClearRequested={() => setUsers([])}
                          getSuggestionValue={(suggestion) => `${suggestion.user_attributes.email}`}
                          renderSuggestion={renderSuggestion}
                          renderInputComponent={renderInputComponent}
                          shouldRenderSuggestions={shouldRenderSuggestions}
                          onSuggestionSelected={(event, {suggestion}) => {
                            if(suggestion.user_attributes.email.length > 0)
                            {
                              stageEmail[index] = {value: ''}
                              setStageEmail([...stageEmail])
                              onSuggestionSelection(formik.values.children_attributes[index].member_ids, suggestion.user_attributes.id, formik.values.children_attributes[index].members, {email: suggestion.user_attributes.email, name_initials: suggestion.user_attributes.name_initials, name: suggestion.user_attributes.name })
                              formik.validateForm();
                            }
                          }
                          }
                          inputProps={{
                            className: `${PageStyle.Form__Input} ${PageStyle.Form__textleft} ${PageStyle.Form__InputFullWidth}`,
                            placeholder: t('placeholder:search:type_name'),
                            value: stageEmail[index].value,
                            index: index,
                            formik: formik,
                            disabled: !editable,
                            editable: editable,
                            selectedValues: formik.values.children_attributes[index].members,
                            closeIcon: <Close/>,
                            styleError:InputError(formik, `children_attributes.${index}.member_ids`),
                            name: `children_attributes.${index}.member_ids`,
                            onChange: (value, {newValue, method}) => {
                              stageEmail[index] = {value: newValue}
                              setStageEmail([...stageEmail])
                            },
                            stageEmail: stageEmail,
                            setStageEmail: setStageEmail,
                            // onKeyDown: (event) => handleKeyDown(event, formik, index, stageEmail, setStageEmail)
                          }}
                        >
                        </Autosuggest>
                        <AutocompleteError
                          name={`children_attributes.${index}.member_ids`}
                          errorClass={PageStyle.Form__Error}
                          formik = {formik}
                          style={InputError(formik, `children_attributes.${index}.member_ids`)}
                        />
                       </div>
                    </div>
                  </div>
                  <div className = { `${AutomationStyle.AutomationPopup__Row}`}>
                     <div className = {`${AutomationStyle.AutomationPopup__Duration}  ${PageStyle.Form__TableCol} mt20 mb10`}>
                        <label className={`Dpflex ${PageStyle.Form__FloatingLabel} ${gridClass(current_interview_type)}`} style = {InputText(formik, `children_attributes.${index}.duration`)}>
                          <span className={`red-color`}>*</span>&nbsp;{t('modal:input:duration')} ({t('modal:input:mins')})
                        </label>
                       <div className = {`${AutomationStyle.AutomationPopup__Field}`}>
                          <FormikControl
                            className={`${PageStyle.Form__Input} ${AutomationStyle.AutomationPopup__Input}`}
                            control="input"
                            type="text"
                            autocomplete="off"
                            placeholder={t('placeholder:eg:15')}
                            formik = {formik}
                            maxLength = {3}
                            custom_class = {`FieldError`}
                            name={`children_attributes.${index}.duration`}
                            value = {formik.values.children_attributes[index].duration}
                            onChange={(evt) => {
                                    addInterviewManualAction.handleDurationChange(
                                      evt,
                                      formik,
                                      index,
                                      setTotalDuration
                                    );
                                  }}
                            style = {InputError(formik, `children_attributes.${index}.duration`)}
                          ></FormikControl>
                       </div>
                     </div>
                   </div>
                  </div>}

                  {/* Interview Type Video */}

                  {current_interview_type == INTERVIEW_TYPES.VIDEO && <div className = {`${AutomationStyle.InterviewType__Video}`}>
                    <div className = { `${AutomationStyle.AutomationPopup__Row}`}>
                      <div className = {`${AutomationStyle.AutomationPopup__w33} ${PageStyle.Form__TableCol} mt30 mb10 pr0`}>
                        <label className={`Dpflex ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, `children_attributes.${index}.integration_id`)}>
                          <span className={`red-color`}>*</span>&nbsp;{t('modal:input:platform')}
                        </label>
                       <div className = {`${AutomationStyle.AutomationPopup__Field}`}>
                          <FormikControl
                            className       =   {`${PageStyle.Form__CustomSelect} ${PageStyle.width100}`}
                            control         =     "select"
                            formik          =   {formik}
                            placeholder     =  { t('placeholder:select:default')}
                            options         =   {platforms}
                            components      =   {{ Option: IconOption }}
                            onChange        =   {(option) => {
                              formik.setFieldValue(`children_attributes.${index}.integration_id`, option.value)
                              if(option.label.toString() != 'Custom Link') formik.setFieldValue(`children_attributes.${index}.meeting_link`, '')
                            }}
                            default         =   {formik.values.children_attributes[index].integration_id}
                            name            =   {`children_attributes.${index}.integration_id`}
                            style           =   {InputError(formik, `children_attributes.${index}.integration_id`)}
                            custom_class    =   {`FieldError`}
                          />
                        </div>
                      </div>
                      <div className = {`${AutomationStyle.AutomationPopup__Duration} ${AutomationStyle.AutomationPopup__w33} ${gridClass(current_interview_type)} ${PageStyle.Form__TableCol} mt30 mb10 mt0`}>
                          <label className={`Dpflex ${PageStyle.Form__FloatingLabel}`} style = {InputText(formik, `children_attributes.${index}.duration`)}><span className={`red-color`}>*</span>&nbsp;{t('modal:input:duration')} ({t('modal:input:mins')})
                          </label>
                        <div className = {`${AutomationStyle.AutomationPopup__Field}`}>
                          <FormikControl
                            className={`${PageStyle.Form__Input} ${AutomationStyle.AutomationPopup__Input}`}
                            control="input"
                            type="text"
                            autocomplete="off"
                            placeholder={t('placeholder:eg:15')}
                            formik = {formik}
                            maxLength = {3}
                            custom_class = {`FieldError`}
                            name={`children_attributes.${index}.duration`}
                            value = {formik.values.children_attributes[index].duration}
                            onChange={(evt) => {
                                    addInterviewManualAction.handleDurationChange(
                                      evt,
                                      formik,
                                      index,
                                      setTotalDuration
                                    );
                                  }}
                            style = {InputError(formik, `children_attributes.${index}.duration`)}
                          ></FormikControl>
                        </div>
                      </div>

                      <div className = {`${AutomationStyle.AutomationPopup__Duration} ${AutomationStyle.AutomationPopup__w33} ${gridClass(current_interview_type)} ${PageStyle.Form__TableCol} mt30 mb10`}>

                          <label className={`Dpflex ${PageStyle.Form__FloatingLabel}`} style = {InputText(formik, `children_attributes.${index}.meeting_link`)}>{t('modal:input:meeting_link')} {isCustomLink(platforms, formik.values.children_attributes[index].integration_id) ? '' : '*'}</label>
                        <div className = {`${AutomationStyle.AutomationPopup__Field}`}>
                          <FormikControl
                            className={`${PageStyle.Form__Input} ${AutomationStyle.AutomationPopup__Input}`}
                            control="input"
                            type="text"
                            autocomplete="off"
                            placeholder=""
                            formik = {formik}
                            custom_class = {`FieldError`}
                            name={`children_attributes.${index}.meeting_link`}
                            value = {formik.values.children_attributes[index].meeting_link}
                            disabled = {isCustomLink(platforms, formik.values.children_attributes[index].integration_id)}
                            style = {InputError(formik, `children_attributes.${index}.meeting_link`)}
                          ></FormikControl>
                        </div>
                       </div>
                    </div>
                    <div className = { `${AutomationStyle.AutomationPopup__Row}`}>
                      <div className = {`${AutomationStyle.AutomationPopup__Members} mt30 mb10 ${PageStyle.Form__TableCol}`}>
                       <label className={`${PageStyle.Form__FloatingLabel}`} style={InputText(formik, `children_attributes.${index}.member_ids`)}>
                        <span className={`red-color`}>*</span>&nbsp;{t('modal:input:members')}</label>

                       <div className = {`${AutomationStyle.AutomationPopup__Field}`}>
                          <Autosuggest
                          suggestions={users}
                          onSuggestionsFetchRequested={({value}) => onSuggestionsFetchRequested(value, currentStage, setUsers, router)}
                          onSuggestionsClearRequested={() => setUsers([])}
                          getSuggestionValue={(suggestion) => `${suggestion.user_attributes.email}`}
                          renderSuggestion={renderSuggestion}
                          renderInputComponent={renderInputComponent}
                          shouldRenderSuggestions={shouldRenderSuggestions}
                          onSuggestionSelected={(event, {suggestion}) => {
                            if(suggestion.user_attributes.email.length > 0)
                            {
                              stageEmail[index] = {value: ''}
                              setStageEmail([...stageEmail])
                              onSuggestionSelection(formik.values.children_attributes[index].member_ids, suggestion.user_attributes.id, formik.values.children_attributes[index].members, {email: suggestion.user_attributes.email, name_initials: suggestion.user_attributes.name_initials, name: suggestion.user_attributes.name })
                              formik.validateForm();
                            }
                          }
                          }
                          inputProps={{
                            className: `${PageStyle.Form__Input} ${PageStyle.Form__textleft}`,
                            placeholder: t('placeholder:search:type_name'),
                            value: stageEmail[index].value,
                            index: index,
                            formik: formik,
                            selectedValues: formik.values.children_attributes[index].members,
                            closeIcon: <Close/>,
                            disabled: !editable,
                            editable: editable,
                            name: `children_attributes.${index}.member_ids`,
                            onChange: (value, {newValue, method}) => {
                              stageEmail[index] = {value: newValue}
                              setStageEmail([...stageEmail])
                            },
                            styleError: InputError(formik, `children_attributes.${index}.member_ids`),
                            stageEmail: stageEmail,
                            setStageEmail: setStageEmail,
                            // onKeyDown: (event) => handleKeyDown(event, formik, index, stageEmail, setStageEmail)
                          }}
                        >
                        </Autosuggest>
                        <AutocompleteError
                          name={`children_attributes.${index}.member_ids`}
                          errorClass={PageStyle.Form__Error}
                          formik = {formik}
                          style={InputError(formik, `children_attributes.${index}.member_ids`)}
                        />
                       </div>
                      </div>
                    </div>
                    <div className={`${AutomationStyle.AutomationPopup__CloseIcon}`}>
                        { (interviewStageCount != 1) && <img src="/icons/close.png" alt="" className={`mt0`} onClick={() => onAutomationChange(formik, "remove", index, setStageEmail, setInterviewStageCount, setTotalDuration, current_interview_type, setShowHideButton)} /> }
                    </div>
                  </div>}

                  {/* Interview Type Face2Face */}
                  {current_interview_type == INTERVIEW_TYPES.FACE2FACE && <div className = {`${AutomationStyle.InterviewType__Face2Face}`}>
                    <div className = { `${AutomationStyle.AutomationPopup__Row}`}>
                      <div className = {`${AutomationStyle.AutomationPopup__Location} ${AutomationStyle.AutomationPopup__w50} ${PageStyle.Form__TableCol} mt30 mb10`}>
                          <label className={`Dpflex ${gridClass(current_interview_type)} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, 'default_location')}>
                          <span className={`red-color`}>*</span>&nbsp;{t('modal:input:location')}
                          </label>
                        <div className = {`${AutomationStyle.AutomationPopup__Field}`}>
                          <PlaceAutoComplete
                            value={formik.values.default_location}
                            onChange={(value) => {
                              formik.setFieldValue('default_location', value)
                              formik.setFieldValue('place_id', "")
                            }}
                            onSelect={(address, placeId, suggestion) => {
                              formik.setFieldValue('default_location', address)
                              formik.setFieldValue('place_id', placeId)
                            }}
                            shouldFetchSuggestions={formik.values.default_location.length >= 3}
                            >
                            {({ getInputProps, getSuggestionItemProps, suggestions,loading }) => (
                              <div className="autocomplete-root">
                                <input
                                className={PageStyle.Form__Input}
                                name={`default_location`}
                                placeholder={t('placeholder:eg:london')}
                                style={InputError(formik, `default_location`)}
                                {...getInputProps({disabled: !editable || isLocationDisabled(formik, index)})} />
                                <div className="autocomplete-dropdown-container">
                                  {loading && <div>{t('loading')}</div>}
                                  {suggestions.map(suggestion => (
                                    <div key={suggestion.placeId} {...getSuggestionItemProps(suggestion)}>
                                      <span key={suggestion.id}>{suggestion.description}</span>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </PlaceAutoComplete>
                          <AutocompleteError
                            name={'default_location'}
                            errorClass={PageStyle.Form__Error}
                            custom_class = {`FieldError`}
                            formik = {formik}
                            style={InputError(formik, 'default_location')}
                            custom_error_90={'custom_error_90'}
                          />
                        </div>
                      </div>
                      <div className = {`${AutomationStyle.AutomationPopup__Duration} ${AutomationStyle.AutomationPopup__w50} mt0 ${PageStyle.Form__TableCol} mt30 mb10`}>
                          <label className={`Dpflex ${gridClass(current_interview_type)} ${PageStyle.Form__FloatingLabel}`} style = {InputText(formik, `children_attributes.${index}.duration`)}>
                            <span className={`red-color`}>*</span>&nbsp;<span>{t('modal:input:duration')} ({t('modal:input:mins')})</span>
                          </label>
                        <div className = {`${AutomationStyle.AutomationPopup__Field}`}>
                            <FormikControl
                              className={`${PageStyle.Form__Input} ${AutomationStyle.AutomationPopup__Input}`}
                              control="input"
                              type="text"
                              autocomplete="off"
                              placeholder={t('placeholder:eg:15')}
                              formik = {formik}
                              maxLength = {3}
                              custom_class = {`FieldError`}
                              name={`children_attributes.${index}.duration`}
                              value = {formik.values.children_attributes[index].duration}
                              onChange={(evt) => {
                                    addInterviewManualAction.handleDurationChange(
                                      evt,
                                      formik,
                                      index,
                                      setTotalDuration
                                    );
                                  }}
                              style = {InputError(formik, `children_attributes.${index}.duration`)}>
                            </FormikControl>
                        </div>
                      </div>
                    </div>
                    <div className = { `${AutomationStyle.AutomationPopup__Row}`}>
                      <div className = {`${AutomationStyle.AutomationPopup__Members} ${PageStyle.Form__TableCol} mt30 mb10`}>
                          <label className={`${gridClass(current_interview_type)} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, `children_attributes.${index}.member_ids`)}>
                            <span className={`red-color`}></span>&nbsp;{t('modal:input:members')}</label>
                        <div className = {`${AutomationStyle.AutomationPopup__Field}`}>
                          <Autosuggest
                          suggestions={users}
                          onSuggestionsFetchRequested={({value}) => onSuggestionsFetchRequested(value, currentStage, setUsers, router)}
                          onSuggestionsClearRequested={() => setUsers([])}
                          getSuggestionValue={(suggestion) => `${suggestion.user_attributes.email}`}
                          renderSuggestion={renderSuggestion}
                          renderInputComponent={renderInputComponent}
                          shouldRenderSuggestions={shouldRenderSuggestions}
                          onSuggestionSelected={(event, {suggestion}) => {
                            if(suggestion.user_attributes.email.length > 0)
                            {
                              stageEmail[index] = {value: ''}
                              setStageEmail([...stageEmail])
                              onSuggestionSelection(formik.values.children_attributes[index].member_ids, suggestion.user_attributes.id, formik.values.children_attributes[index].members, {email: suggestion.user_attributes.email, name_initials: suggestion.user_attributes.name_initials, name: suggestion.user_attributes.name })
                              formik.validateForm();
                            }
                          }
                          }
                          inputProps={{
                            className: `${PageStyle.Form__Input} ${PageStyle.Form__textleft} ${PageStyle.Form__InputFullWidth}`,
                            placeholder: t('placeholder:search:type_name'),
                            value: stageEmail[index].value,
                            index: index,
                            formik: formik,
                            disabled: !editable,
                            editable: editable,
                            selectedValues: formik.values.children_attributes[index].members,
                            closeIcon: <Close/>,
                            name: `children_attributes.${index}.member_ids`,
                            onChange: (value, {newValue, method}) => {
                              stageEmail[index] = {value: newValue}
                              setStageEmail([...stageEmail])
                            },
                            styleError: InputError(formik, `children_attributes.${index}.member_ids`),
                            stageEmail: stageEmail,
                            setStageEmail: setStageEmail,
                            // onKeyDown: (event) => handleKeyDown(event, formik, index, stageEmail, setStageEmail)
                          }}
                        >
                        </Autosuggest>
                        <AutocompleteError
                          name={`children_attributes.${index}.member_ids`}
                          errorClass={PageStyle.Form__Error}
                          formik = {formik}
                          style={InputError(formik, `children_attributes.${index}.member_ids`)}
                        />
                       </div>
                      </div>
                    </div>
                    <div className={`${AutomationStyle.AutomationPopup__CloseIcon}`}>
                        { (interviewStageCount != 1) && <img src="/icons/close.png" alt="" className={`mt0`} onClick={() => onAutomationChange(formik, "remove", index, setStageEmail, setInterviewStageCount, setTotalDuration, current_interview_type, setShowHideButton)} /> }
                    </div>
                </div>}
            </>)
          })}}></FieldArray>

                  <div className={`dnone ${PageStyle.addbtnposition}`}>
                  {formik.values.interview_type_id && [INTERVIEW_TYPES.VIDEO, INTERVIEW_TYPES.FACE2FACE].includes(current_interview_type) && showHideButton &&
                    <div className={`mt20`}><Button buttonstyle={`${ButtonStyle.iconTextButton} mt0`} type="button" onClick={() => {
                        onAutomationChange(formik, "add", undefined, setStageEmail, setInterviewStageCount, setTotalDuration, current_interview_type, setShowHideButton)
                      }}
                        >
                        <AddIcon />
                   {t('button:add:interview')}
                    </Button>
                    </div>
                  }
                </div>

                {[INTERVIEW_TYPES.PHONE, INTERVIEW_TYPES.VIDEO, INTERVIEW_TYPES.FACE2FACE].includes(current_interview_type)  && <div className={'mt30'}>
                  <div className="d-flex justify-content-between align-items-center mt20">
                    <div className={`WrapperRadio w100`}>
                      <label className={`Dpflex WrapperRadioContainer WrapperRadiocheckmarkfont mb0`}>
                      <Field type="radio" name="date_range" id="option-1" value={true} onChange={(event)=> {
                        formik.setFieldValue('date_range', true)
                        let children_attributes = formik.values.children_attributes
                                                              children_attributes.map((x) => {
                                                                x.start_time = ''
                                                                x.end_time = ''
                                                                return x
                                                              })
                        setAddType('range')
                      }}/>
                        <span className="WrapperRadiocheckmark m0"></span> <span className={`ml5`}>{t('modal:automation:candidate_availability')}</span>
                      </label>

                      <label className={`Dpflex WrapperRadioContainer WrapperRadiocheckmarkfont mb0 ${!isSingleCandidate ? 'disabledClass' : 'notdisabled'}`}>
                      <Field type="radio" name="date_range" id="option-2" value={false} disabled={!isSingleCandidate} onChange={(event)=> {
                        formik.setFieldValue('date_range', false)
                        let children_attributes = formik.values.children_attributes
                                                              children_attributes.map((x) => {
                                                                x.start_time = ''
                                                                x.end_time = ''
                                                                return x
                                                              })
                        setAddType('time')
                      }}/>
                        <span className="WrapperRadiocheckmark m0"></span> <span className={`ml5`}>{t('modal:input:select_date_time')}</span>
                      </label>


                    </div>
                    </div>

                    {current_interview_type == '' && <div className="heightauto"></div> }
                    {addType == 'range' && <div className="heightauto"></div>}

                    {!formik.values.date_range &&
                      <FieldArray name="children_attributes" render={(arrayHelpers) =>
                      {return formik.values.children_attributes.map((item, index) => {
                      return (!item._destroy &&
                      <div className={`${PageStyle.SetupPopup__ContentAddInterview} ${ModalStyle.AddInterview__ContentAddInterview} ${PageStyle.mtb25}`} key={`interview_round_${index}`}>
                        <div className={`${PageStyle.SetupPopup__ContentFlex} ${PageStyle.Form__TableCol} width145`}>
                          <label className={`${PageStyle.Form__FloatingLabel}`} style = {InputText(formik, `children_attributes.${index}.date`)}><span className={`red-color`}>*</span>&nbsp;{t('modal:input:interview_date')}</label>
                          <FormikControl
                            control         =   "customKeyboardPicker"
                            className       =   {'JobCustomDateTime'}
                            format          =   {'DD/MM/YYYY'}
                            inputProps      =   {{
                                                  readOnly: false,
                                                  style:   InputError(formik, `children_attributes.${index}.date`),
                                                }}
                            minDate         =   { new Date(new Date().setDate(new Date().getDate())) }
                            minDateMessage  =   {`Interview date must be present or future date`}
                            disablePast     =   { true }
                            placeholder     =   "dd/mm/yyyy"
                            name            =   {`children_attributes.${index}.date`}
                            onChange        =   { async (date)=> {
                                                    await formik.setFieldValue(`children_attributes.${index}.date`, date.format('DD/MM/YYYY'))
                                                  }
                                                }
                            formik          =   {formik}
                            custom_class  = {"form_custom_error"}

                            value           =   {  typeof formik.values.children_attributes[index].date == 'string' ? setFilledDate(formik.values.children_attributes[index].date) : formik.values.children_attributes[index].date}
                          />
                        </div>
                       <div className={`${PageStyle.SetupPopup__ContentFlex} ${PageStyle.Form__TableCol} Timebg`}>
                       <label className={`${PageStyle.Form__FloatingLabel}`} style= {InputText(formik, `children_attributes.${index}.starttime`)}><span className={`red-color`}>*</span>&nbsp;{t('time:start')}</label>
                        <FormikControl  control      =  {"timeinput"}
                          disabled     =  {false}
                          value        =  {formik.values.children_attributes[index].starttime}
                          fullTimeDropdown = {true}
                          allowDelete  =  {true}
                          hour12Format =  {false}
                          onChange  = {(dateString) => {
                              formik.setFieldValue(`children_attributes.${index}.starttime`, dateString)
                              formik.setFieldValue(`children_attributes.${index}.endtime`, addMinutes(dateString, formik.values.children_attributes[index].duration))
                            }
                          }
                          inputProps = {{
                            style:  InputError(formik, `children_attributes.${index}.starttime`),
                          }}
                          errorClass   =  {PageStyle.Form__Error}
                          name = {`children_attributes.${index}.starttime`}
                          formik = {formik}
                          custom_class  = {"form_custom_error"}
                          manuallyDisplayDropdown={true}
                        />
                        </div>

                        <div className={`${PageStyle.SetupPopup__ContentFlex} ${PageStyle.Form__TableCol} Timebg`}>
                        <label className={`${PageStyle.Form__FloatingLabel}`} style= {InputText(formik, `children_attributes.${index}.endtime`)}><span className={`red-color`}>*</span>&nbsp;{t('time:end')}</label>
                        <FormikControl  control      =  {"timeinput"}
                          disabled     =  {true}
                          value        =  {formik.values.children_attributes[index].endtime}
                          fullTimeDropdown = {false}
                          allowDelete  =  {true}
                          hour12Format =  {false}
                          onChange  = {(dateString) => {
                              formik.setFieldValue(`children_attributes.${index}.endtime`, dateString)
                            }
                          }
                          inputProps = {{
                            style:  InputError(formik, `children_attributes.${index}.endtime`),
                          }}
                          errorClass   =  {PageStyle.Form__Error}
                          name = {`children_attributes.${index}.endtime`}
                          formik = {formik}
                          custom_class  = {"form_custom_error"}
                          manuallyDisplayDropdown={true}
                        />
                        </div>
                      </div>
                      )})}
                    }></FieldArray>
                    }
                  </div>}







                 {formik.values.interview_type_id && [INTERVIEW_TYPES.PHONE, INTERVIEW_TYPES.VIDEO, INTERVIEW_TYPES.FACE2FACE].includes(current_interview_type) && <div className={`${PageStyle.SetupPopup__Duration} ${AutomationStyle.AutomationPopup__TotalDuration}`}>
                      <h3>{t('time:total_duration')}</h3>
                      <span>{totalDuration} {t('time:mins')}</span>
                    </div>}
              </div>

          }
            {current_interview_type == INTERVIEW_TYPES.TECHTEST && <div className={`${PageStyle.SetupPopup__ContentBlock}`}>
              <div className = { `${AutomationStyle.AutomationPopup__Row}`}>
                <div className = {`${AutomationStyle.AutomationPopup__Members} ${PageStyle.Form__TableCol} mt30 mb10`}>
                      <label className={`${PageStyle.Form__FloatingLabel}`} style={InputText(formik, `job_test_detail_attributes.member_emails`)}>
                        {t('modal:input:members')}
                      </label>
                  <div className = {`${AutomationStyle.AutomationPopup__Field}`}>
                    <Autosuggest
                      suggestions={users}
                      onSuggestionsFetchRequested={({value}) => onSuggestionsFetchRequested(value, currentStage, setUsers, router)}
                      onSuggestionsClearRequested={() => setUsers([])}
                      getSuggestionValue={(suggestion) => `${suggestion.user_attributes.email}`}
                      renderSuggestion={renderSuggestion}
                      renderInputComponent={techTestAction.renderMemberInputComponent}
                      shouldRenderSuggestions={techTestAction.shouldRenderSuggestions}
                      onSuggestionSelected={(event, {suggestion}) => {
                        if(suggestion.user_attributes.email.length > 0)
                        {
                          setTechStageEmail({value: ''})
                          techTestAction.onSuggestionSelection(formik.values.job_test_detail_attributes.member_emails, suggestion.user_attributes.email, formik.values.job_test_detail_attributes.member_initials, {email: suggestion.user_attributes.email, name_initials: suggestion.user_attributes.name_initials, name: suggestion.user_attributes.name })
                          formik.validateForm();
                        }
                      }}
                      inputProps={{
                        className: `${PageStyle.Form__Input} ${PageStyle.Form__textleft}`,
                        placeholder: t('placeholder:search:type_name'),
                        value: techStageEmail.value,
                        disabled: !editable,
                        editable: editable,
                        formik: formik,
                        selectedValues: formik.values.job_test_detail_attributes?.member_initials,
                        closeIcon: <Close/>,
                        techTestAction: techTestAction,
                        add_button: false,
                        name: `job_test_detail_attributes.member_emails`,
                        onChange: (value, {newValue, method}) => {
                          setTechStageEmail({value: newValue, error: ''})
                        },
                        setStageEmail: setTechStageEmail,
                        // onKeyDown: (event) => techTestAction.handleKeyDown(event, formik, setTechStageEmail)
                      }
                      }
                    >
                  </Autosuggest>
                  <AutocompleteError
                    name={`job_test_detail_attributes.member_emails`}
                    errorClass={PageStyle.Form__Error}
                    formik = {formik}
                    style={InputError(formik, `job_test_detail_attributes.member_emails`)}
                    />
                  </div>
                </div>
              </div>
            </div>}


            {current_interview_type == INTERVIEW_TYPES.TECHTEST &&
            <>
{/*             <div className={` WrapperRadioDpBlock`}> */}
{/*               <div className={` WrapperRadioGrid mt20`}> */}
{/*                 <label className={`Dpflex WrapperRadioContainer`}> */}
{/*                   <Field type="radio" name="job_test_detail_attributes.test_type" id="test_type_1" value={'TestLibrary'} checked={formik.values.job_test_detail_attributes?.test_type == 'TestLibrary'} onChange={(event)=> techTestAction.onOptionChange(formik, event, setTechTest, validationData, setValidationData, 'original')} /> */}
{/*                   <span className="WrapperRadiocheckmark ml0"></span> */}
{/*                   <span className={`ml5 WrapperRadioSpan fw500`}> {t('modal:input:ikm_tech_test')}</span> */}
{/*                 </label> */}
{/*  */}
{/*                 <label className={`Dpflex WrapperRadioContainer`}> */}
{/*                   <Field type="radio" name="job_test_detail_attributes.test_type" id="test_type_2" value={'Assessment'} checked={formik.values.job_test_detail_attributes?.test_type == 'Assessment'} onChange={(event)=> techTestAction.onOptionChange(formik, event, setTechTest, validationData, setValidationData, 'original')} /> */}
{/*                   <span className="WrapperRadiocheckmark ml0"></span> */}
{/*                   <span className={`ml5 WrapperRadioSpan fw500`}> {t('modal:input:your_tech_test')}</span> */}
{/*                 </label> */}
{/*               </div> */}
{/*             </div> */}
{/*  */}
{/*             <div className={`${PageStyle.NeedHelp}`}> */}
{/*             {validationData.type == 'TestLibrary' && <p className={`mt0`}>{t('modal:automation:which_assessment_to_send')} <a href="https://ikmnet.com/products/skills-assessments/" target="_blank">{t('click_here')}</a> {t('for_help_guide')}</p>} */}
{/*             </div> */}

            <div className={`${PageStyle.SetupPopup__ContentGridTech} UploadTest cpblock mb25`}>
              <div className = {`${AutomationStyle.AutomationPopup__Field} ${PageStyle.Form__TableCol} mt30 mb10`}>
                  <label className={`${PageStyle.Form__FloatingLabel}`} style={InputText(formik, "job_test_detail_attributes.test_id")}><span className={`red-color`}>*</span>&nbsp;{t('modal:input:test_name')}</label>
                <Autosuggest
                  suggestions={tests}
                  onSuggestionsFetchRequested={(value) => techTestAction.onSuggestionsFetchRequested(value, techTestAction, formik.values.job_test_detail_attributes.test_type, false, t)}
                  onSuggestionsClearRequested={() => setTests([])}
                  getSuggestionValue={techTestAction.getSuggestionValue}
                  renderSuggestion={techTestAction.renderSuggestion}
                  renderInputComponent={techTestAction.renderInputComponent}
                  shouldRenderSuggestions={() => formik.values.job_test_detail_attributes.test_type == 'Assessment' ? true : techTestAction.shouldRenderSuggestions}
                  onSuggestionSelected={(event, {suggestion}) => {
                    setTechTest(suggestion.name);
                    formik.setFieldValue("job_test_detail_attributes.test_id", suggestion.id)
                    techTestAction.setCustomTestOptions(formik, suggestion.id.toString(), validationData, setValidationData)
                  }}
                  inputProps={{
                    className: `${PageStyle.Form__Input} input350`,
                    placeholder: t('placeholder:eg:java_test'),
                    value: techTest,
                    disabled: !props.editable,
                    onChange: (value, {newValue, method}) => {
                      setTechTest(newValue)
                      formik.setFieldValue("job_test_detail_attributes.test_id",'')
                    },
                    name: "job_test_detail_attributes.test_id",
                    styleError: InputError(formik, "job_test_detail_attributes.test_id")
                  }
                  }
                >
                </Autosuggest>
                <AutocompleteError
                  name="job_test_detail_attributes.test_id"
                  errorClass={PageStyle.Form__Error}
                  formik = {formik}
                  custom_class = {`FieldError`}
                  style={InputError(formik, "job_test_detail_attributes.test_id")}
                />
              </div>
              <div className = {`${AutomationStyle.AutomationPopup__FieldAuto}`}>
                <div className={`${PageStyle.Form__TableCol} mt30 mb10`}>
                <label className={`${PageStyle.Form__FloatingLabel}`} style={InputText(formik, 'job_test_detail_attributes.days_to_expire')}>
                  <span className={`red-color`}>*</span>&nbsp;{t('modal:input:expires')}
                </label>
                <div className = {`${AutomationStyle.AutomationPopup__FieldAuto} ${AutomationStyle.AutomationPopup__NoRightBorderRadius} w50`}>
                      <div className = {`${AutomationStyle.AutomationPopup__NoRightBorderRadius} Dpflexonly`}>
                        <Field
                          component={addInterviewManualAction.NumberField}
                          type="text"
                          autocomplete="off"
                          placeholder={t('placeholder:eg:5')}
                          className={`${PageStyle.Form__Input} ${AutomationStyle.Form__InputFocus} thresholdmodl width70`}
                          formik = {formik}
                          maxLength = {2}
                          name="job_test_detail_attributes.days_to_expire"
                          format={'###'}
                          style={InputError(formik, 'job_test_detail_attributes.days_to_expire')}
                          onChange= { (evt) => {
                              let new_value = isNaN(evt.target.value) ? 1 : (parseInt(evt.target.value) == 0 ? '' : evt.target.value)
                              formik.setFieldValue("job_test_detail_attributes.days_to_expire", new_value)
                              return new_value
                            }}
                        />
                        <span
                        className = {`${AutomationStyle.AutomationPopup__Seconds} ${PageStyle.Form__currency_symbol} ${PageStyle.Form__currency_symbol__right} ml0`}
                        style={InputError(formik, 'job_test_detail_attributes.days_to_expire')}
                        >{t('modal:input:days')}</span>
                      </div>
                      <AutocompleteError
                          name="job_test_detail_attributes.days_to_expire"
                          errorClass={PageStyle.Form__Error}
                          formik={formik}
                          custom_class = {`FieldError`}
                          style={InputError(formik, 'job_test_detail_attributes.days_to_expire')}
                      />
                    </div>
                  </div>
              </div>
            </div>

            {formik.values.job_test_detail_attributes?.test_id?.toString() == 'upload_new_test' && <div className={`${PageStyle.SetupPopup__AssesmentsectionNew} asessment-form-section`}>
              <div className={`${PageStyle.SetupPopup__ContentBlock} ${PageStyle.mt25}`}>
                <div className={`${PageStyle.SetupPopup__ContentBlock} ${PageStyle.Form__TableCol}`}>
                  <label className={`${PageStyle.Form__FloatingLabel}`} style =   {InputText(formik, "job_test_detail_attributes.assessment.name")}>{t('modal:input:enter:assessment:name')}</label>
                  <FormikControl
                    className     =   {`assesmentlbl ${PageStyle.Form__Input} ${ModalStyle.Form__Input}`}
                    control       =   "input"
                    type          =   "text"
                    errorClass    =   {PageStyle.Form__Error}
                    custom_class  = {"form_custom_error"}
                    formik        =   {formik}
                    name          =   "job_test_detail_attributes.assessment.name"
                    style         =   {InputError(formik, "job_test_detail_attributes.assessment.name")}
                  />
                </div>

                <div className={`${PageStyle.SetupPopup__ContentBlock} ${PageStyle.Form__TableCol} mt40`}>
                      <label className={`${PageStyle.Form__FloatingLabel}`} style = {InputText(formik, "job_test_detail_attributes.assessment.link")}>{t('modal:input:enter:assessment:link')}</label>
                      <FormikControl
                        className     =   {`${PageStyle.Form__Input} ${ModalStyle.Form__Input}`}
                        control       =   "input"
                        placeholder   =   {t('placeholder:eg:5')}
                        type          =   "text"
                        formik        =   {formik}
                        name          =   "job_test_detail_attributes.assessment.link"
                        errorClass    =   {PageStyle.Form__Error}
                        custom_class  = {"form_custom_error"}
                        disabled      =   {false}
                        style         =   {InputError(formik, "job_test_detail_attributes.assessment.link")}
                        onChange      =   {
                          (event) => {
                            if(event.target.value.length == 0 && formik.values.file){
                              formik.setFieldValue('job_test_detail_attributes.assessment.file_type', 'file')
                            }
                            else{
                              formik.setFieldValue('job_test_detail_attributes.assessment.file_type', 'link')
                            }
                            formik.setFieldValue('job_test_detail_attributes.assessment.link', event.target.value)
                          }
                        }
                      />
                    </div>
                    <div className = {`${ModalStyle.DividerOr} ${ModalStyle.AutomationDividerOr}`}>
                    {t('upload:or')}
                    </div>

                  <div className = {`UploadAssessment ${ModalStyle.UploadAssessment} ${PageStyle.SetupPopup__ContentBlock} ${PageStyle.mt0}`}>
                      <span className={`${ModalStyle.LabelNote}`}>{t('upload:supported_files')}</span>
                      <div className = {`${ModalStyle.DropBox} ${PageStyle.Form__TableCol} mt10`}>
                      <label className={`mb10 ${PageStyle.Form__FloatingLabel}`}>{t('upload:assessment')}</label>
                       <div className={`${PageStyle.Form__DropBoxcontainer} ${ModalStyle.Assessment__Form__DropBoxcontainer}`}>
                          <AssessmentDropZone id='upload_assessment' type={'automation'} name={'job_test_detail_attributes.assessment.file'} multiple={false} formRef={formRef} formik={formik} autofill={false} accept={".pdf, .docx, .doc"}
                            dropAction={techTestAction}
                            drop_type={'template'}
                          />
                        </div>
                      </div>
                    </div>
              </div>
            </div>}
            </>
            }
              <div className={`${PageStyle.SetupPopup__FooterNew} `}>
                {(current_interview_type == INTERVIEW_TYPES.TECHTEST) && (validationData.type == 'Assessment') && (validationData.test_id == 'upload_new_test') ? <>
                <div className={PageStyle.SetupPopup__SubmitSectionSave}>
                  <Tooltip content={t('tooltip:test_template')} background= {'#00325A'} radius={20} padding = {12} placement  = "top" fontSize= "12px" className='SimpleTooltip'>
                    <p className={`SaveTooltip`}>
                    <Button buttonstyle={`${ButtonStyle.primarybtn} ${cursorNone(props.editable)}`} type="button" disabled = {!props.editable} onClick={
                      ()=> {
                        setButtonState('save_and_continue')
                        // if((formik.values.job_test_detail_attributes.assessment.link.length > 0 && formik.values.job_test_detail_attributes.assessment.file) || (formik.values.job_test_detail_attributes.assessment.link.length == 0 && !formik.values.job_test_detail_attributes.assessment.file)){
                        //   customToastrAction.setNormalToastr(t('errors:assessment_link_error'), 'warning');
                        // }
                        // else{
                          formik.submitForm()
                        // }
                      }
                    }>
                   {t('button:save_and_continue')}
                    </Button>
                    </p>
                  </Tooltip>
                  <Button buttonstyle={`${ButtonStyle.secondarybtnborder} ${cursorNone(props.editable)}`} type="button" disabled = {!props.editable} onClick={
                    ()=> {
                      setButtonState('continue_without_saving')
                      formik.submitForm();
                    }
                  }>
                  {[INTERVIEW_TYPES.PHONE, INTERVIEW_TYPES.VIDEO, INTERVIEW_TYPES.FACE2FACE].includes(current_interview_type) && addType == "time" ? t('button:review_send') : t('button:continue_without_saving')}
                  </Button>
                 </div>
                </> :
                <div className={`${PageStyle.SetupPopup__SubmitSectionSave} ${AutomationStyle.AutomationPopup__SubmitSectionSave}`}>
                  {/* {[INTERVIEW_TYPES.PHONE, INTERVIEW_TYPES.FACE2FACE, INTERVIEW_TYPES.VIDEO, INTERVIEW_TYPES.VIDEOQA].includes(current_interview_type) && <Button buttonstyle={`${ButtonStyle.secondarybtn} mr10`} type="button" onClick={async() => { */}
                  {/*     let data = await reviewAutomationEmail((props.job_id || props.jobData.id), router, {key: 'move_candidates', stage_id: currentStage.id, list: true, interview_type_id: formik.values.interview_type_id}); */}
                  {/*     props.setEmailData(data); */}
                  {/*     props.setHideModalClass(true) */}
                  {/*     props.emailTemplateInfo.job_stage_id = currentStage.id */}
                  {/*     props.setEmailTemplateInfo(props.emailTemplateInfo) */}
                  {/*     props.setReviewEmail(true); */}
                  {/*   }}> */}
                  {/*  Review Email */}
                  {/* </Button>} */}
                  <Button buttonstyle={`${ButtonStyle.primarybtn} ${cursorNone(editable)}`} disabled={isDisabled || !editable} type="button" onClick={async() => {
                      await setSendInterview(true)
                     formik.submitForm();
                  }} >
              {t('button:review_send')}
                  </Button>
                </div>
                }
              </div>


              </div>
            </Form>
           )}
        </Formik>
        
    }
    />
  )
}

SetupInterviewModal.layout = ClientDashboard;
export default SetupInterviewModal;